import script from "./Job.vue?vue&type=script&setup=true&lang=js"
export * from "./Job.vue?vue&type=script&setup=true&lang=js"

import "./Job.vue?vue&type=style&index=0&id=2078c9a2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2078c9a2"]])

export default __exports__